<template>
  <div class="Info">
    <div class="NoData" v-if="TypeData == 0">
      <div class="NoDataMsg">您还未申请专业机构</div>
      <div class="NoDataBtn" @click="ApplyFor">申请</div>
    </div>
    <div class="QueryCont" v-if="TypeData == 1">
      <div class="QueryContItem" v-for="item in Data" :key="item.id">
        <!-- <div class="InfoTit">
                    {{ item.name }}:
                    <span v-if="item.status !== 'normal'" class="HuiYaunIcon">{{ item.status_info }}</span>
                    <span v-if="item.status == 'normal'" class="HuiYaunIcon">您是 {{ item.user_group_List }} 正式会员</span>
                </div> -->
        <div class="QueryContItemTit">
          <div class="iconfont icon-shujidaoru"></div>
          <div class="QueryContItemNameWrapper">
            <span class="QueryContItemName">{{ item.name }}</span>
            <span class="QueryContItemStatus">
              （
              {{ item.type === 0 ? "注册:" : "更新注册:" }}
              <span v-if="item.status == 0">待提交</span>
              <span v-if="item.status == 1">申请待缴费</span>
              <span v-if="item.status == 2">形式待审核</span>
              <span v-if="item.status == 3">形式审查返回修改</span>
              <span v-if="item.status == 4">专家待审核</span>
              <span v-if="item.status == 5">专家驳回返回修改</span>
              <span v-if="item.status == 6">领导待审批</span>
              <span v-if="item.status == 7">领导审批驳回返回修改</span>
              <span v-if="item.status == 8">评审待缴费</span>
              <span v-if="item.status == 9">待公示</span>
              <span v-if="item.status == 10">公示中</span>
              <span v-if="item.status == 11">待缴注册费</span>
              <span v-if="item.status == 12">待领导完成</span>
              <span v-if="item.status == 13">领导完成不通过返回修改</span>
              <span v-if="item.status == 14">完成</span>
              <span v-if="item.status == 15">评审中</span>
              ）
            </span>
          </div>
          <div class="QueryContItemDis">
            <!-- <div :class="[item == 1 ? 'ColorGreen' : item == 2 ? 'ColorYellow' : 'ColorRed']">
                            {{ item.id == 1 ? '初级' : item.id == 2 ? '中级' : '高级' }}注册心理咨询师</div> -->
            <div>
              {{ item.user_group.length ? item.user_group[0].name : "" }}
            </div>

            <!-- <div v-if="item.status == 'normal'"> {{ item.user_group_List }}</div>
                        <div v-if="item.status == 'normal'">注册号:{{ item.code }}</div> -->
            <!-- <div class="NoDataBtn NoDataBtn1" @click="UpdateRegistration(item.user_group_id)">更新注册</div> -->
            <!-- <div class="EdiBtn">
                            <el-button  v-if="item.status <= 0" size="mini"
                                @click="GoEdit(item)">编辑</el-button>
                            <el-button v-else size="mini"
                                @click="GoDetail(item)">详情</el-button>
                            <el-button  size="mini"
                                @click="UpdateRegistration(item.user_group_id)">更新注册</el-button>
                            <el-button  size="mini">支付</el-button>
                        </div> -->
            <div class="EdiBtn">
              <div
                v-if="
                  item.status <= 0 ||
                  item.status === 3 ||
                  item.status === 5 ||
                  item.status === 7 ||
                  item.status === 13
                "
                @click="GoEdit(item)"
                style="text-decoration: underline"
              >
                编辑
              </div>
              <div
                v-if="
                  item.status <= 0 ||
                  item.status === 3 ||
                  item.status === 5 ||
                  item.status === 7 ||
                  item.status === 13
                "
                @click="GoDetail(item)"
                style="text-decoration: underline"
              >
                详情
              </div>
              <div
                v-else
                @click="GoDetail(item)"
                style="text-decoration: underline"
              >
                详情
              </div>
              <div
                v-if="item.status === 14"
                @click="UpdateRegistration(item.user_group_id, item.id)"
                style="text-decoration: underline"
              >
                更新注册
              </div>
              <!-- <div
                v-if="item.status === 14"
                @click="DownloadCertificate(item)"
                style="text-decoration: underline"
              >
                下载证书
              </div> -->
              <div
                v-if="item.status == 1 || item.status == 8 || item.status == 11"
                style="text-decoration: underline"
                @click="GoToOrder"
              >
                支付
              </div>
            </div>
          </div>
        </div>
        <div class="QueryContItemTit" v-if="item.status == 14">
          <div style="width: 18px"></div>

          <div class="QueryContItemDis">
            <div>注册号：{{ item.code }}</div>
            <div>
              注册期：{{
                item.passtime
                  ? item.passtime.split(" ")[0].replace(/-/g, "/")
                  : ""
              }}—{{
                new Date(item.certificate_end_time * 1000)
                  .toLocaleDateString()
                  .replace(/-/g, "/")
              }}
            </div>
          </div>
        </div>
        <div class="QueryContItemCont">
          <!-- <div class="QueryContItemImg">
                        <img src="../../assets/img/zhengShu.jpg" alt="">
                    </div> -->
          <!-- <div class="QueryContItemTxt">
                        <div class="State">
                            <div class="StateTit">注册状态</div>
                            <div class="StateTag"
                                :class="[item.status == 'hidden' ? 'BgBlue' : (item.status == 'publicity' || item.status == 'normal') ? 'BgGreen' : 'BgRed']">
                                <span v-if="item.status == 'hidden'">未审核</span>
                                <span v-if="item.status == 'publicity'">公示中</span>
                                <span v-if="item.status == 'normal'">公示完成</span>
                                <span v-if="item.status == 'shenhe_hidden'">审核驳回</span>
                                <span v-if="item.status == 'publicity_hidden'">公示驳回</span>
                            </div>
                        </div>
                        <div>{{ item.synopsis }}</div>
                    </div> -->
        </div>
      </div>
      <div class="PageDis">
        <el-pagination
          background
          :page-sizes="[10, 20, 50]"
          layout="prev,pager,next,total,sizes"
          @size-change="SizeChange"
          @current-change="PageChange"
          :total="total"
          :current-page="page"
          :hide-on-single-page="true"
        ></el-pagination>
      </div>
    </div>
    <PopDetail ref="ref1" :companyDetails="companyDetails" />
  </div>
</template>

<script>
import PopDetail from "@/components/user/AgenciesComponents/PopDetail";
const processStatus = {
  fenpei: "未审核",
  hidden: "未审核",
  publicity: "公式中",
  normal: "公示完成",
  publicity_hidden: "公示驳回",
  shenhe_hidden: "审核驳回",
};
export default {
  data() {
    return {
      Data: [],
      Blon: false,
      total: 0,
      page: 1,
      companyDetails: {},
    };
  },
  components: {
    PopDetail,
  },
  props: {
    TypeData: "",
  },
  mounted() {
    this.GetData();
  },
  methods: {
    GetData() {
      this.$get("api/user/companySearch", {
        page: this.page,
        limit: this.SizePage,
      }).then((res) => {
        this.Data = [];
        if (res.data.code == 1) {
          this.total = res.data.data.total;
          res.data.data.data.forEach((item) => {
            item.status_info = processStatus[item.status];
            var user_group_List = [];
            if (item.user_group.length) {
              item.user_group.forEach((items) => {
                user_group_List.push(items.name);
              });
              item.user_group_List = user_group_List.join(",");
            }
          });
          this.Data = res.data.data.data;
        }
      });
    },
    GoEdit(row) {
      console.log("准备编辑数据:", row);
      if (!row) {
        this.$message.error("数据不完整，请刷新页面重试");
        return;
      }

      // 先获取详细数据，然后跳转
      const params = {
        register_major_company_id: row.id,
      };

      // 如果是更新注册，添加type参数
      if (row.type === 1) {
        params.type = 1;
      }

      this.$get("api/user/companySearchDetails", params)
        .then((res) => {
          if (res.data.code == 1) {
            // 将详细数据直接存储到localStorage
            const detailData = res.data.data;

            // 确保列表页的user_group信息被传递
            detailData.user_group = row.user_group || [];

            // 直接使用详情数据
            localStorage.setItem("InfoData", JSON.stringify(detailData));
            this.$router.push({ path: "/ApplyReg?type=2" });
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.error("获取详细数据失败:", err);
          this.$message.error("获取详细数据失败，请重试");
        });
    },
    GoDetail(row) {
      const params = {
        register_major_company_id: row.id,
      };

      // 如果是更新注册，添加type参数
      if (row.type === 1) {
        params.type = 1;
      }

      this.$get("api/user/companySearchDetails", params).then((res) => {
        if (res.data.code == 1) {
          this.companyDetails = res.data.data;
          this.$refs.ref1.OpenReviewBlon();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    ApplyFor() {
      this.$router.push({
        path: "/ApplyReg?type=2&stste=1",
        query: {
          type: 2,
        },
      });
    },
    UpdateRegistration(uid, id) {
      this.$router.push({
        path: "/updateRegistration",
        query: {
          typeId: 2,
          uid: uid,
          id: id,
        },
      });
    },
    SizeChange(val) {
      this.SizePage = val;
      this.GetData();
    },
    PageChange(val) {
      this.page = val;
      this.GetData();
    },
    GoToOrder() {
      // Implement the logic to go to order page
      this.$emit("TogglePage", 5);
    },
    DownloadCertificate(row) {
      if (!row) {
        this.$message.error("数据不完整，请刷新后重试");
        return;
      }

      // cid: 1 初级/默认，2 中级，3 高级
      // type: 1 督导师，2 心理咨询师
      const userGroupId = parseInt(row.user_group_id, 10);
      let cid = 1;
      let type = 2;
      if (userGroupId === 1) {
        cid = 1;
        type = 2;
      } else if (userGroupId === 2) {
        cid = 2;
        type = 2;
      } else if (userGroupId === 3) {
        cid = 3;
        type = 2;
      } else if (userGroupId === 4) {
        cid = 1;
        type = 1;
      }

      const code = row.code || "";
      const date = row.passtime ? row.passtime.split(" ")[0] : "";

      const fd = new FormData();
      fd.append("cid", cid);
      fd.append("type", type);
      fd.append("code", code);
      fd.append("date", date);

      this.$post("api/Certificate/getMyCertificate", fd)
        .then((res) => {
          if (res.data && res.data.code == 1) {
            const url =
              res &&
              res.data &&
              res.data.data &&
              (res.data.data.uploadUrl ||
                (res.data.data.raw && res.data.data.raw.path_url));
            if (!url) {
              this.$message.error("证书下载链接为空，请稍后重试");
              return;
            }
            this.DownloadByUrl(url);
          } else {
            this.$message.error((res.data && res.data.msg) || "获取证书失败");
          }
        })
        .catch((err) => {
          console.error("getMyCertificate error:", err);
          this.$message.error("获取证书失败，请重试");
        });
    },
    // 尽量使用 blob 下载，避免浏览器直接预览并跳到 PDF 标签页
    DownloadByUrl(url) {
      if (!url) return;

      const fileName = (() => {
        try {
          const path = url.split("?")[0] || "";
          const last = path.split("/").pop() || "certificate.pdf";
          return decodeURIComponent(last);
        } catch (e) {
          return "certificate.pdf";
        }
      })();

      try {
        const xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.responseType = "blob";
        xhr.onload = () => {
          if (xhr.status === 200 && xhr.response) {
            const objectUrl = window.URL.createObjectURL(xhr.response);
            const a = document.createElement("a");
            a.href = objectUrl;
            a.download = fileName;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(objectUrl);
          } else {
            this.DownloadByIframe(url);
          }
        };
        xhr.onerror = () => {
          this.DownloadByIframe(url);
        };
        xhr.send();
      } catch (e) {
        this.DownloadByIframe(url);
      }
    },
    DownloadByIframe(url) {
      // 兜底：通过隐藏 iframe 触发下载，避免当前页跳转
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = url;
      document.body.appendChild(iframe);
      setTimeout(() => {
        if (iframe && iframe.parentNode) {
          iframe.parentNode.removeChild(iframe);
        }
      }, 30000);
    },
  },
};
</script>
<style scoped>
.InfoTit {
  padding: 10px 0;
  font-weight: 400;
  font-size: 16px;
  color: #000000;
}

.HuiYaunIcon {
  padding: 5px 10px;
  background: #e3faff;
  font-weight: 400;
  font-size: 16px;
  color: #0385eb;
}

.NoData {
  margin: 0 auto;
  text-align: center;
}

.NoDataMsg {
  padding: 60px 0;
  font-weight: 400;
  font-size: 16px;
  color: #000000;
  text-align: center;
}

.NoDataBtn {
  cursor: pointer;
  width: 90px;
  font-weight: 400;
  font-size: 20px;
  color: #ffffff;
  padding: 7px 15px;
  border-radius: 20px;
  background: #0385eb;
  margin: 0 auto;
}

.QueryContItemTit {
  padding: 10px;
  padding-right: 200px;
  color: #fff;
  font-size: 16px;
  background: #0286eb;
  display: flex;
  align-items: center;
  position: relative;
}

.QueryContItemTit .iconfont {
  /* font-weight: 700; */
  flex-shrink: 0;
}

.QueryContItemTit div {
  margin-right: 20px;
}

.QueryContItemTit div:last-child {
  margin-right: 0;
}

.QueryContItemNameWrapper {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.QueryContItemName {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-shrink: 1;
  min-width: 0;
}

.QueryContItemStatus {
  flex-shrink: 0;
  white-space: nowrap;
}

.EdiBtn {
  display: flex;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  right: 10px;
  cursor: pointer;
  gap: 15px;
  flex-shrink: 0;
  background: #0286eb;
  padding-left: 10px;
}

.QueryContItemDis {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.QueryContItemDis .icon-message {
  font-weight: 100;
  cursor: pointer;
}

.QueryContItemCont {
  padding: 10px 0 20px 0;
  display: flex;
}

.QueryContItemImg {
  width: 100%;
}

.State {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.StateTit {
  font-weight: 400;
  font-size: 16px;
  color: #999;
}

.StateTag {
  margin-left: 10px;
  padding: 3px 15px;
}

.StateTag.BgBlue {
  background: #e8f3fc;
  border: 1px solid #9cc1f1;
  color: #3a83e4;
}

.StateTag.BgGreen {
  background: #e4f9ef;
  border: 1px solid #a4eaca;
  color: #49d696;
}

.StateTag.BgRed {
  background: #fac2c2;
  border: 1px solid #d51938;
  color: #d51938;
}

.QueryContItemTxt {
  flex: 1;
  line-height: 30px;
  font-size: 16px;
  color: #737373;
}

.PageDis {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.QueryCont .NoDataBtn1 {
  margin: 0;
  margin-bottom: 10px;
  text-align: center;
  font-size: 16px;
}

@media only screen and (max-width: 550px) {
  .QueryContItemTit {
    justify-content: space-between;
  }

  .QueryContItemTit div {
    margin: 0;
  }

  .QueryContItemDis {
    display: block;
  }
}
</style>
